import { Link } from "react-router-dom";
import { useTitle } from "@/lib/site";

export default function NotFound() {
  useTitle("Page not found | YK Motors");
  return (
    <section className="container-x py-24 text-center lg:py-32" data-testid="not-found-page">
      <p className="eyebrow justify-center">404</p>
      <h1 className="mt-4 font-display text-4xl font-extrabold sm:text-5xl">We can't find that page</h1>
      <p className="mx-auto mt-4 max-w-md text-steel">The link may be out of date. Try our stock or head back home.</p>
      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
        <Link to="/used-cars" className="btn btn-primary" data-testid="not-found-stock-button">
          View Stock
        </Link>
        <Link to="/" className="btn btn-outline" data-testid="not-found-home-button">
          Back to home
        </Link>
      </div>
    </section>
  );
}
